import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../config";

function LoginPage({ setLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
        }),
      });

      const contentType = res.headers.get("content-type") || "";

      if (!contentType.includes("application/json")) {
        const text = await res.text();
        console.error("Non-JSON response:", text);
        throw new Error("Backend returned HTML instead of JSON. Check API URL.");
      }

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || "Login failed");
      }

      localStorage.setItem("loggedIn", "true");
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("admin_id", data.admin_id);
      localStorage.setItem("username", data.username);
      localStorage.setItem("role", data.role);
      localStorage.setItem("company_id", data.company_id ?? "");

      setLoggedIn(true);

      if (data.role === "super_admin") {
        navigate("/dashboard");
      } else {
        navigate("/client-dashboard");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Invalid username or password");
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-brand-wrap">
          <div className="login-logo">WP</div>
          <h1>Wireless Press</h1>
          <p className="login-tagline">
            Endpoint Control, Kiosk Enforcement, and Device Visibility — all in
            one console.
          </p>

          <div className="login-feature-list">
            <div className="login-feature-item">✓ Live device check-in monitoring</div>
            <div className="login-feature-item">✓ Policy-based app control</div>
            <div className="login-feature-item">✓ Kiosk enforcement for managed devices</div>
            <div className="login-feature-item">✓ Centralized admin dashboard</div>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">
          <div className="login-card-header">
            <h2>Admin Sign In</h2>
            <p>Access the Wireless Press management console.</p>
          </div>

          <form onSubmit={handleLogin}>
            <div className="login-form-group">
              <label>Username</label>
              <input
                type="text"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="login-form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button type="submit" className="login-button">
              Sign In
            </button>
          </form>

          {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}

          <div className="login-footer-note">
            Wireless Press Lockdown Console
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;